import React, { useEffect, useState } from 'react';
import { Card, CardBody, Col } from "reactstrap";
import SimpleBar from "simplebar-react";
import { useSelector, useDispatch } from "react-redux";
import { fetchRecentActiveRequest } from "../../store/Dashboard/dashboardAction";

const AndroidOnlineDevices = () => {
    const [data, setData] = useState("");
    const [selectedDays, setSelectedDays] = useState(1);

    const dispatch = useDispatch();
    const { data: androidRecentActive } = useSelector(
        (state) => state.androidRecentActive
    );

    useEffect(() => {
        dispatch(fetchRecentActiveRequest(selectedDays));
    }, [dispatch, selectedDays]);

    useEffect(() => {
        if (androidRecentActive !== undefined) {
            setData(androidRecentActive)
        }
    }, [androidRecentActive]);

    const handleSelectChange = (event) => {
        const days = parseInt(event.target.value, 10);
        setSelectedDays(days);
    };

    return (
        <React.Fragment>
            <Col lg={4}>
                <Card>
                    <CardBody>
                        <div className="float-end">
                            <select
                                className="form-select form-select-sm"
                                value={selectedDays}
                                onChange={handleSelectChange}
                            >
                                <option value={1}>24 hrs</option>
                                <option value={3}>3 Days</option>
                                <option value={7}>7 Days</option>
                            </select>
                        </div>

                        <h4 className="card-title mb-4 mt-2">Recent Active Devices</h4>

                        <div className="text-center border rounded py-3 mb-3">
                            <p className="mb-2">Total Online Devices</p>
                            <h4>{data.totalCount || 0}</h4>
                        </div>

                        <SimpleBar style={{ maxHeight: "230px" }}>
                            <ul className="list-unstyled">
                                {data.devices && data.devices.map((item, index) => (
                                    <li className="p-2 border" key={index}>
                                        <div><span className='me-4'>{index + 1}.  </span>{item}</div>
                                    </li>
                                ))}
                            </ul>
                        </SimpleBar>
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default AndroidOnlineDevices;
